import { createContext } from 'react';

import { TableContextReturnType } from 'types/components/table/context-return.type';

export const TableContext = createContext<TableContextReturnType | null>(null);
